const MIN_DWELL_MS = 1500;
const pageReadyAt = Date.now();

function ensureHoneypot(form) {
  if (form.querySelector('input[name="website"]')) return;
  const hp = document.createElement('input');
  hp.type = 'text';
  hp.name = 'website';
  hp.className = 'hp-field';
  hp.tabIndex = -1;
  hp.setAttribute('autocomplete', 'off');
  hp.setAttribute('aria-hidden', 'true');
  form.appendChild(hp);
}

function ensureStatusEl(form) {
  let el = form.querySelector('.form-status');
  if (!el) {
    el = document.createElement('p');
    el.className = 'form-status';
    el.setAttribute('aria-live', 'polite');
    form.appendChild(el);
  }
  return el;
}

function showFakeSuccess(form) {
  const status = ensureStatusEl(form);
  form.querySelectorAll('.input, button[type="submit"]').forEach((el) => {
    el.disabled = true;
  });
  const btn = form.querySelector('button[type="submit"]');
  if (btn) btn.textContent = 'Done';
  status.textContent = "You're on the list — Gene will be in touch.";
  status.classList.remove('is-error');
  status.classList.add('is-success');
}

// Called from a submit handler on a submission that is going through.
// The browser builds the form data *after* submit handlers return (and
// Shopify's hCaptcha re-submits via form.submit() later still), and it
// omits disabled fields — so lock inputs with readOnly, never disabled.
function lockFormForSubmit(form, busyLabel) {
  // The button has no name, so disabling it doesn't drop any data.
  const btn = form.querySelector('button[type="submit"]');
  if (btn) {
    btn.textContent = busyLabel;
    btn.disabled = true;
  }
  // readOnly fields are still submitted; disabled ones are not.
  form.querySelectorAll('.input').forEach((el) => {
    el.readOnly = true;
  });
  form.setAttribute('aria-busy', 'true');
}

const capture = document.querySelector('.js-capture');
const emailInput = document.querySelector('.js-email');
const submitBtn = document.querySelector('.js-submit');

if (capture && emailInput && submitBtn) {
  ensureHoneypot(capture);

  capture.addEventListener('submit', (e) => {
    const email = emailInput.value.trim();
    if (!email || !email.includes('@')) {
      e.preventDefault();
      emailInput.focus();
      return;
    }

    const hp = capture.querySelector('input[name="website"]');
    if ((hp && hp.value) || Date.now() - pageReadyAt < MIN_DWELL_MS) {
      e.preventDefault();
      showFakeSuccess(capture);
      return;
    }

    // Valid email — let the form submit to Shopify's customer endpoint.
    lockFormForSubmit(capture, 'Submitting...');
  });
}

const burger = document.querySelector('.js-burger');
const dropdown = document.querySelector('.js-dropdown');

if (burger && dropdown) {
  const closeDropdown = () => {
    dropdown.classList.remove('is-open');
    burger.setAttribute('aria-expanded', 'false');
  };
  const openDropdown = () => {
    dropdown.classList.add('is-open');
    burger.setAttribute('aria-expanded', 'true');
  };

  burger.addEventListener('click', (e) => {
    e.stopPropagation();
    dropdown.classList.contains('is-open') ? closeDropdown() : openDropdown();
  });

  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target) && e.target !== burger) closeDropdown();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDropdown();
  });
}

/* === storefront: contact form spam defense === */
document.querySelectorAll('.js-contact-form').forEach((form) => {
  ensureHoneypot(form);

  form.addEventListener('submit', (e) => {
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const email = emailInput ? emailInput.value.trim() : '';
    if (!email || !email.includes('@')) {
      e.preventDefault();
      if (emailInput) emailInput.focus();
      return;
    }

    const hp = form.querySelector('input[name="website"]');
    if ((hp && hp.value) || Date.now() - pageReadyAt < MIN_DWELL_MS) {
      e.preventDefault();
      showFakeSuccess(form);
      const status = ensureStatusEl(form);
      status.textContent = "Thanks for reaching out — Gene will get back to you soon.";
      return;
    }

    lockFormForSubmit(form, 'Sending...');
  });
});
